<template>
  <nav role="navigation">
    <div id="menu-toggle" class="menu-toggle">
      <input type="checkbox" @change="onClick" />

      <span></span>
      <span></span>
      <span></span>

      <ul id="menu" class="menu">
        <a href="#app" @click="closeNav"><li>Home</li></a>
        <a href="#about" @click="closeNav"><li>About</li></a>
        <a href="#shop" @click="closeNav"><li>Merch</li></a>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    onClick(event) {
      console.log('event', event.target.checked)
      // const checked = event.target.checked
      // checked ? document.body.style.overflow = "hidden" : 
    },
    closeNav() {
      const input = document.querySelector('#menu-toggle input[type="checkbox"]')
      input.checked = false
    }
  }
}
</script>

<style scoped lang="scss">
nav {
  position: absolute;
  right: 0;
  top: 0;
}

.menu-toggle {
  display: block;
  position: relative;
  width: 33px;
  height: 22px;
  z-index: 1;
  -webkit-user-select: none;
  user-select: none;
  padding: 16px 12px;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
}

.menu-toggle a {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
  margin: 16px 0 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 600;

  &:hover {
    color: tomato;
  }

  &:focus {
    outline: none;
  }
}

.menu-toggle input {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;  
  opacity: 0; /* hide this */
  z-index: 2; /* and place it over the hamburger */
  -webkit-touch-callout: none;
}

.menu-toggle span {
  display: block;
  width: 105%;
  height: 4px;
  margin-bottom: 5px;
  position: relative;
  background-color: #cdcdcd;
  background-color: white;
  border-radius: 3px;
  z-index: 1;
  transform-origin: 4px 0px;
  transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
              background-color 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
              opacity 0.55s ease;
}

.menu-toggle span:first-child {
  transform-origin: 0% 0%;
}

.menu-toggle span:nth-last-child(2) {
  transform-origin: 0% 100%;
}

/* 
 * Transform all the slices of hamburger
 * into a crossmark.
 */
.menu-toggle input:checked ~ span {
  opacity: 1;
  transform: rotate(45deg) translate(-2px, -1px);
  background-color: red;
  width: 126%;
}

/*
 * But let's hide the middle one.
 */
.menu-toggle input:checked ~ span:nth-last-child(3) {
  opacity: 0;
  transform: rotate(0deg) scale(0.2, 0.2);
}

/*
 * Ohyeah and the last one should go the other direction
 */
.menu-toggle input:checked ~ span:nth-last-child(2) {
  transform: rotate(-45deg) translate(0, -1px);
}

.menu {
  position: fixed;
  width: 0;
  max-width: 300px;
  height: 100vh;
  margin: 0;
  right: 0;
  top: 0;
  padding: 0;
  padding-top: 55px;
  display: flex;
  flex-direction: column;
  background-color: rgb(0 0 0 / 85%);
  list-style-type: none;
  -webkit-font-smoothing: antialiased;
  /* to stop flickering of text in safari */
  
  transform-origin: 0% 0%;
  transform: translate(105%, 0);
  
  // transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);
  transition: all 0.5s cubic-bezier(0.77,0.2,0.05,1.0);

  li {
    padding: 10px 0;
    font-size: 24px;
  }
}

/*
 * And let's slide it in from the left
 */
.menu-toggle input:checked ~ ul {
  transform: none;
  width: 100vw;
}

@media screen and (min-width: 768px) {
  .menu {
    padding: 50px;
    padding-top: 87px;

    li {
      padding: 16px 0;
    }
  }
}
</style>
